import layout from '@/components/common/layout';
import salaryList from '../views/salary/list';
import salaryView from '../views/salary/view';

export default [
    {
        path: '/salary',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "工资列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'salary_list',// 子选项
                    }
                },
                component: salaryList,
            },
            {
                path: 'view',
                meta: {
                    metaInfo: {
                        title: "工资明细",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '12',// 父选项
                        child: 'salary_list',// 子选项
                    }
                },
                component: salaryView,
            },
        ]
    },
];
